module.exports = __webpack_public_path__ + "static/media/icon_arrow_left_gray.a051ff88.svg";